module.exports = __webpack_public_path__ + "img/grey.51a6dbdc.jpg";